import { CAMPAIGN_RESOURCE } from "signoxe/api/resources";
import {API_ROOT} from '../constants/config';
import {
  ADD_CAMPAIGN,
  ADD_FILE_TO_CAMPAIGN,
} from "signoxe/constants/actionTypes";
import { addResource, fetchResource, deleteResource, getAuthTokenHeader } from "./remote";

import { fetchAssets } from "./asset";

export const fetchCampaigns = fetchResource(CAMPAIGN_RESOURCE);

export const deleteCampaign = deleteResource(CAMPAIGN_RESOURCE);

export const addCampaign = addResource(CAMPAIGN_RESOURCE);

export const addCampaignAction = (data) => ({
  type: ADD_CAMPAIGN,
  payload: data,
});

export const addFileToCampaignAction = (data) => ({
  type: ADD_FILE_TO_CAMPAIGN,
  payload: data,
});


export const moveAssets = (id, assets) => dispatch => {
  const url = `${API_ROOT}assets-mod/`;
  const options = {
  method: "PUT",
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      "Authorization": getAuthTokenHeader()
  },
  body: JSON.stringify({ campaign: id, id_list: assets })

  };
  fetch(url, options)
  .then(dispatch(fetchAssets(true)))
  .then((response) => {response.json()})
  .then(data => {
      console.log(data);
});
}


export const deleteAssets = (assets) => dispatch => {
  const url = `${API_ROOT}assets-mod/`;
  const options = {
  method: "DELETE",
  headers: {
      Accept: "application/json",
      "Content-Type": "application/json;charset=UTF-8",
      "Authorization": getAuthTokenHeader()
  },
  body: JSON.stringify({ campaign: 0, id_list: assets })

  };
  fetch(url, options)
  .then(data => {
      console.log(data);
}).then(dispatch(fetchAssets(true)))
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/campaign.js